import { generateApiRoute } from '@klp/core/api/helpers';

export const supportFormApiName = 'form';

export const supportFormApiRoutes = {
    form: () => generateApiRoute([supportFormApiName]),
    formById: (formId: string | number) =>
        generateApiRoute([supportFormApiName, formId]),
    formFiles: (formId: string | number) =>
        generateApiRoute([supportFormApiName, 'file', formId]),
};
